import { Component, HostBinding, Inject, OnDestroy, OnInit } from '@angular/core';

import { DialogType, ModalDialogService } from '@frontend/sports/modal/feature';
import { ClipboardService } from '@frontend/vanilla/shared/clipboard';
import { Store } from '@ngrx/store';
import { Subscription, filter } from 'rxjs';

import { WidgetComponent } from '../../../../lib/widget/core/widget-registry.service';
import { IAffiliateMessages } from '../../../base/models/betslip-messages';
import { BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN, IBetslipMessagesProviderService } from '../../../base/services/betslip-messages-provider.service';
import { IBetslipRootState } from '../../../base/store/state';
import { IAffiliateLink } from '../affiliate.model';
import AffiliateActions from '../state/affiliate.actions';
import { affiliateLinkStateSelector } from '../state/affiliate.selectors';

@Component({
    selector: 'bs-affiliate-helper',
    templateUrl: 'affiliate-helper.component.html',
    styleUrls: ['./affiliate-helper.component.scss'],
    standalone: false,
})
export class AffiliateHelperComponent extends WidgetComponent<never> implements OnInit, OnDestroy {
    @HostBinding('class') className = 'betslip betslip-vars-scope affiliate-helper';

    includeType = false;
    includeCurrency = false;
    includeStake = false;
    includePage = false;
    source = '';

    private affiliateLinkSubscription: Subscription;
    messages: IAffiliateMessages;

    constructor(
        private store: Store<IBetslipRootState>,
        private clipboardService: ClipboardService,
        private modalDialogService: ModalDialogService,
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService,
    ) {
        super();
        this.messages = messageProvider.getMessages().affiliate as IAffiliateMessages;
    }

    ngOnInit() {
        this.affiliateLinkSubscription = this.store
            .select(affiliateLinkStateSelector)
            .pipe(filter((state: IAffiliateLink | null) => state != null))
            .subscribe((link: IAffiliateLink | null) => {
                if (link?.url && link.url !== '') {
                    const decodedUrl = decodeURI(link.url);

                    if (!link.isMixed) {
                        this.clipboardService.copy(decodedUrl);
                    }

                    this.showMessage(this.messages.CopiedMessage, link.isMixed, decodedUrl);
                } else {
                    this.showMessage(this.messages.EmptyMessage, false);
                }

                this.store.dispatch(AffiliateActions.resetAffiliateState());
            });
    }

    ngOnDestroy(): void {
        this.affiliateLinkSubscription.unsubscribe();
    }

    clear(): void {
        this.includeType = false;
        this.includeCurrency = false;
        this.includeStake = false;
        this.includePage = false;
        this.source = '';
    }

    copy = (): void =>
        this.store.dispatch(
            AffiliateActions.generateAffiliateLink({
                payload: {
                    addPage: this.includePage,
                    addType: this.includeType,
                    addStake: this.includeStake,
                    addCurrency: this.includeCurrency,
                    source: this.source,
                },
            }),
        );

    toggle(): void {
        if (!this.includeStake) {
            this.includeCurrency = false;
        }
    }

    private showMessage(message: string, isMixed: boolean, url?: string): void {
        this.modalDialogService.openMessage(
            {
                type: DialogType.Info,
                title: this.messages.Header,
                firstParagraph: isMixed ? this.messages.InvalidDeepLinkMixedBets : message,
                secondParagraph: isMixed ? ' ' : url,
                showCloseLink: true,
            },
            {
                cssClass: 'affiliate-popup',
            },
        );
    }
}
